module.exports = __webpack_public_path__ + "img/cpany7.8a8e93a6.png";